module.exports = __webpack_public_path__ + "img/pHORP-7000.6ca38868.png";